import { Button } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)`
    width: 100%;
    font-size: 14px;

    svg {
        font-size: 16px;
    }
`;
